document.addEventListener("DOMContentLoaded", function () {
	const navbarToggler = document.querySelector(".navbar-toggler")
	const btnHdd = document.querySelector(".btn-hdd")
	const navbarCollapse = document.querySelector(".navbar-collapse")
	const btnMb = document.querySelector(".btn-mb")

	function handleResize() {
		if (window.innerWidth < 992) {
			btnMb.classList.add("d-flex")
			if (btnHdd.classList.contains("d-none")) {
				btnMb.classList.add("justify-content-end")
			} else {
				btnMb.classList.remove("justify-content-end")
			}
		} else {
			btnMb.classList.remove("d-flex", "justify-content-end")
		}
	}

	// Verifica o estado inicial
	handleResize()

	// Adiciona o listener para redimensionamento da janela
	window.addEventListener("resize", handleResize)

	if (navbarToggler && btnHdd && navbarCollapse) {
		navbarToggler.addEventListener("click", function () {
			if (window.innerWidth < 992) {
				if (navbarCollapse.classList.contains("show")) {
					btnHdd.classList.remove("d-none")
					btnMb.classList.remove("justify-content-end")
				} else {
					btnHdd.classList.add("d-none")
					btnMb.classList.add("justify-content-end")
				}
			}
		})

		// Verifica o estado inicial
		if (window.innerWidth < 992 && navbarCollapse.classList.contains("show")) {
			btnHdd.classList.add("d-none")
			btnMb.classList.add("justify-content-end")
		}
	}
})
